var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F9FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.0678 48.835C62.6982 47.2355 62.0758 45.8495 62.0758 43.4947V42.694C62.0758 39.6254 61.3695 37.6482 59.834 35.6711C57.4674 32.6006 53.4832 30.75 49.5829 30.75H49.4171C45.5988 30.75 41.7395 32.5156 39.3319 35.4615C37.7125 37.4783 36.9242 39.5404 36.9242 42.694V43.4947C36.9242 45.8495 36.3428 47.2355 34.9322 48.835C33.8942 50.0134 33.5625 51.5278 33.5625 53.1669C33.5625 54.8079 34.101 56.3621 35.1819 57.6254C36.5925 59.1399 38.5846 60.1067 40.6195 60.2748C43.5657 60.6109 46.5119 60.7375 49.5009 60.7375C52.4881 60.7375 55.4343 60.526 58.3823 60.2748C60.4154 60.1067 62.4075 59.1399 63.8181 57.6254C64.8971 56.3621 65.4375 54.8079 65.4375 53.1669C65.4375 51.5278 65.1058 50.0134 64.0678 48.835Z",
    fill: "#4286F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2663 63.0532C52.329 62.853 46.6174 62.853 45.68 63.0532C44.8787 63.2383 44.0122 63.6688 44.0122 64.613C44.0588 65.5138 44.5862 66.3088 45.3167 66.813L45.3148 66.8149C46.2596 67.5513 47.3684 68.0196 48.5293 68.1877C49.148 68.2727 49.7778 68.2689 50.4189 68.1877C51.578 68.0196 52.6868 67.5513 53.6315 66.8149L53.6297 66.813C54.3602 66.3088 54.8875 65.5138 54.9341 64.613C54.9341 63.6688 54.0676 63.2383 53.2663 63.0532Z",
    fill: "#4286F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.8513f2354ff75505de9e6e9ae6c5c005.svg";
export { ForwardRef as ReactComponent };